export function toHankaku(val: string): string {
    return val
        .replace(/[Ａ-Ｚａ-ｚ０-９]/g, x => String.fromCharCode(x.charCodeAt(0) - 0xFEE0))
        .replace(/[-－﹣−‐⁃‑‒–—﹘―⎯⏤ーｰ─━]/g, '-')
}